// Trekkin.app — logger.js v1.1.0 FINAL
// --------------------------------------------------
// ✔ Logger centralizado
// ✔ Console + Store + Persist opcional
// ✔ Compatível iOS / Android / Minify
// ✔ Integrado com useLogsStore (Admin → Logs)
// --------------------------------------------------

import { useLogsStore } from "../stores/useLogsStore";

const MAX_INTERNAL = 500;

class TrekkinLogger {
  constructor() {
    this.logs = [];
    this.enabled = true;
    this.persist = false;
  }

  setEnabled(v) {
    this.enabled = !!v;
  }

  setPersist(v) {
    this.persist = !!v;
    if (this.persist) this._save();
  }

  _save() {
    if (!this.persist) return;
    try {
      localStorage.setItem(
        "trekkin.logger.internal",
        JSON.stringify(this.logs.slice(-MAX_INTERNAL))
      );
    } catch {}
  }

  _push(level, module, message, payload) {
    let logsEnabled = false;
    try {
      logsEnabled = !!useLogsStore.getState()?.logsEnabled;
    } catch {}

    if (!this.enabled && !logsEnabled) {
      return;
    }

    const entry = {
      ts: Date.now(),
      level,
      module,
      message: String(message || ""),
      payload,
    };

    // ---------------- internal/admin capture
    if (logsEnabled) {
      this.logs.push(entry);
      if (this.logs.length > MAX_INTERNAL) this.logs.shift();
      this._save();
    }

    // ---------------- console
    const tag = `[${level.toUpperCase()}] [${module}]`;
    if (this.enabled) {
      if (level === "error") console.error(tag, message, payload || "");
      else if (level === "warn") console.warn(tag, message, payload || "");
      else console.log(tag, message, payload || "");
    }

    // ---------------- Admin Logs
    if (logsEnabled) {
      try {
        const store = useLogsStore.getState();
        if (store?.addLog) {
          const mappedLevel = level === "debug" ? "info" : level;
          if (["error", "warn", "info"].includes(mappedLevel)) {
            store.addLog(
              mappedLevel,
              `[${module}] ${message}`,
              payload ?? null
            );
          }
        }
      } catch {}
    }
  }

  debug(module, message, payload) {
    this._push("debug", module, message, payload);
  }
  info(module, message, payload) {
    this._push("info", module, message, payload);
  }
  warn(module, message, payload) {
    this._push("warn", module, message, payload);
  }
  error(module, message, payload) {
    this._push("error", module, message, payload);
  }

  getLogs() {
    return [...this.logs].reverse();
  }

  clear() {
    this.logs = [];
    try {
      localStorage.removeItem("trekkin.logger.internal");
    } catch {}
  }
}

export const logger = new TrekkinLogger();
